import { Result, Button } from "antd";

import Login from "../Pages/Page/User/login";
import Profile from "../Pages/Page/User/profile";
import Register from "../Pages/Page/User/register";

import Categories from "../Pages/Page/Products/categories";
import Products from "../Pages/Page/Products/products";
import ProductDetails from "../Pages/Page/Products/productDetails";
import PromotionDetails from "../Pages/Page/Products/promotionDetails";

import Home from "../Pages/Page/Common/home";
import AboutUs from "../Pages/Page/Common/aboutUs";
import FAQ from "../Pages/Page/Common/faq";
import StoreLocations from "../Pages/Page/Common/storeLocations";
import ContactUs from "../Pages/Page/Common/contactUs";
import Catalog from "../Pages/Page/Common/catalog";

const routers = [
  {
    path: "/",
    label: "Home",
    key: "home",
    component: Home,
    isPrivate: false,
    isHeader: true,
  },

  {
    path: "/home",
    label: "Home",
    key: "home",
    component: Home,
    isPrivate: false,
    isHeader: false,
  },

  {
    path: "/login",
    label: "Login",
    key: "login",
    component: Login,
    isPrivate: false,
    isHeader: true,
  },
  {
    path: "/profile",
    label: "Profile",
    key: "profile",
    component: Profile,
    isPrivate: true,
    isHeader: true,
  },
  {
    path: "/register",
    label: "Register",
    key: "register",
    component: Register,
    isPrivate: false,
    isHeader: true,
  },

  {
    path: "/categories",
    label: "Categories",
    key: "categories",
    component: Categories,
    isPrivate: false,
    isHeader: true,
  },
  {
    path: "/products",
    label: "Products",
    key: "products",
    component: Products,
    isPrivate: false,
    isHeader: true,
  },
  {
    path: "/product/:slug/:sku/:productId",
    label: "Product Details",
    key: "product-details",
    component: ProductDetails,
    isPrivate: false,
    isHeader: true,
  },

  {
    path: "/company",
    label: "Company",
    key: "company",
    component: AboutUs,
    isPrivate: false,
    isHeader: true,
  },

  {
    path: "/faq",
    label: "FAQ",
    key: "faq",
    component: FAQ,
    isPrivate: false,
    isHeader: true,
  },

  {
    path: "/locate-us",
    label: "Locate Us",
    key: "locate-us",
    component: StoreLocations,
    isPrivate: false,
    isHeader: true,
  },
  {
    path: "/contact-us",
    label: "Contact Us",
    key: "contact-us",
    component: ContactUs,
    isPrivate: false,
    isHeader: true,
  },
  {
    path: "/promotion-details/:promotionId/:slug",
    label: "Promotion Details",
    key: "promotion-details",
    component: PromotionDetails,
    isPrivate: false,
    isHeader: true,
  },
  {
    path: "/catalogues",
    label: "Catalogue",
    key: "catalogue",
    component: Catalog,
    isPrivate: false,
    isHeader: true,
  },

  // 404
  {
    path: "*",
    component: () => (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" href="/" style={{ color: "black" }}>
            Return Home
          </Button>
        }
        style={{
          marginTop: 45,
          height: "100vh",
        }}
      />
    ),
    isPrivate: false,
    isHeader: false,
  },
];

export default routers;
